export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $('[data-toggle-class]').on('click', function(e){
      e.preventDefault();
      const config = $(this).data('toggle-class').split(':');
      const $target = $(config[0]);
      const className = config[1];

      $target.toggleClass(className);
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js